import { render, staticRenderFns } from "./MModalWrapper.vue?vue&type=template&id=3765061a&scoped=true"
import script from "./MModalWrapper.vue?vue&type=script&lang=js"
export * from "./MModalWrapper.vue?vue&type=script&lang=js"
import style0 from "./MModalWrapper.vue?vue&type=style&index=0&id=3765061a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3765061a",
  null
  
)

export default component.exports